export const environment = {
  production: true,
  api_base_url: "https://crm-api.narrativecommunities.com/api/",
  api_raw_base_url: "https://crm-api.narrativecommunities.com/",
  eta_api_base_url: "https://eta.st.fabrica.com.eg/api/",
  base_url: "https://crm.narrativecommunities.com/",
  baseHREF: "/",
  firebase: {
    apiKey: "AIzaSyDl0UnkJ2QluJgGCTJGVHfzEUyY",
    authDomain: "biogrpahy-74a3e.firebaseapp.com",
    projectId: "biogrpahy-74a3e",
    storageBucket: "biogrpahy-74a3e.firebasestorage.app",
    messagingSenderId: "263100086312",
    appId: "1:263100086311:web:ada9900b2671ef1df03602",
    vapidkey:
      "BKkfN72Qv6KSS0di9l6qUxA31W1Mt6OyRkodym8gUc5KnYKBr0tV8EuoVSezv9DOkJ1p9HhVoVmI5pas",
  },
};

// /home/admin/web/staging2.fabrica-dev.com/ssh-ali

//scp -i /home/admin/web/staging2.fabrica-dev.com/ssh-ali/Staging.pem -r * ubuntu@3.138.111.226:/var/www/html/castle-backend/public/uploads



// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts